import { render, staticRenderFns } from "./WorkflowFormSubmissionDepartmentCard.vue?vue&type=template&id=9df1cc40&"
import script from "./WorkflowFormSubmissionDepartmentCard.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionDepartmentCard.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormSubmissionDepartmentCard.vue?vue&type=style&index=0&id=9df1cc40&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports